import React, { FC, useState } from 'react';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './table-menu.css';
import './scrollbar.css';
import { TableColumn } from '../../../models/table/TableColumn';
import settingsIcon from '../../../images/Settings.svg';
import OutsideClick from '../../outside-click/outside-click';
import { generateFieldId } from '../../../utilities/GenerateFieldId';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';

type Props = {
    cols: TableColumn[],
    onSubmit: (colums: any[]) => void,
    onClose: () => void
}

const TableMenu: FC<Props> = ({ cols, onSubmit, onClose }) => {
    const [columns, setColumns] = useState(cols);
    const { translate } = useLocale();

    const handleSelect = (i) => {
        setColumns(cols => cols.map((item, index) => ({ ...item, active: index === i ? !item.active : item.active })));
    };

    const handleMoveUp = (i) => {
        const begin = columns.slice(0, i - 1);
        const after = columns.slice(i + 1, cols.length);
        const newCols = [...begin, columns[i], columns[i - 1], ...after];
        setColumns(newCols);
    };

    const handleMoveDown = (i) => {
        const begin = columns.slice(0, i);
        const after = columns.slice(i + 2, cols.length);
        const newCols = [...begin, columns[i + 1], columns[i], ...after];
        setColumns(newCols);
    };

    const handleSubmit = () => {
        if (columns.every(column => column.active == false)) {
            onSubmit(cols);
        }
        else {
            onSubmit(columns);
        }
    };


    return (
        <OutsideClick onClick={() => onClose()}>
            <div className="table-menu flex flex-col">
                <div className="flex flex-row overflow-y-auto py-4 px-5 wrapper">
                    <div>
                        <div className="rounded-full h-8 w-8 flex items-center justify-center bg-gray-bar">
                            <img src={settingsIcon} alt="" className="w-4 h-4 p-1-5 " />
                        </div>
                    </div>
                    <div className="flex flex-col flex-grow pl-3">
                        <div className="flex flex-col justify-between items-baseline pb-5" id="columnSelectorModal">
                            <span className="text-xl font-semibold">{translate.byKey(TranslationKeys.columns)}</span>
                            <span className="text-sm">{translate.byKey(TranslationKeys.selectOrderColumns)}</span>
                        </div>
                        <div className="pb-2 text-xs flex flex-col overflow-y-auto h-48 scrollbar pr-8">
                            <ul>
                                {columns.map((item, index) => (
                                    <li key={`li-${index}`} className="border-b py-2">
                                        <div className="flex flex-row justify-between items-baseline">
                                            <div>
                                                <input
                                                    disabled={item.isDefault}
                                                    className={item.isDefault ? "mr-3 text-portal-blue-primary cursor-not-allowed" : "mr-3 text-portal-blue-primary"}
                                                    type="checkbox"
                                                    id={generateFieldId(item.heading, 'Checkbox')}
                                                    checked={item.active}
                                                    onChange={() => handleSelect(index)} />
                                                    {translate.byKey(TranslationKeys[item.translationKey]) ?? item.heading}
                                            </div>
                                            <div>
                                                <button
                                                    type="button"
                                                    className={`mx-1 ${(index === columns.length - 1) ? 'text-gray-400 cursor-not-allowed ' : 'text-gray-500'}`}
                                                    disabled={index === columns.length - 1}
                                                    onClick={(event) => handleMoveDown(index)}>
                                                    <FontAwesomeIcon icon={faArrowDown} />
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`mx-1 ${index === 0 ? 'text-gray-400 cursor-not-allowed' : 'text-gray-500'}`}
                                                    disabled={index === 0}
                                                    onClick={() => handleMoveUp(index)}>
                                                    <FontAwesomeIcon icon={faArrowUp} />
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="bg-gray-bar">
                    <div className="px-3 py-2 text-xs flex flex-row justify-between items-baseline">
                        <button
                            type="button"
                            className="text-portal-blue-primary pl-40 py-2 mx-4 right-9"
                            onClick={() => onClose()}>{translate.byKey(TranslationKeys.cancel)}</button>
                        <button
                            type="button"
                            className="bg-portal-blue-primary-shade2 px-8 py-2 mx-4 rounded-full text-white"
                            onClick={handleSubmit} id="columnSelectorButtonId">{translate.byKey(TranslationKeys.done)}</button>
                    </div>
                </div>
            </div>
        </OutsideClick>
    );
}

export default TableMenu;
